import technologies from '../data/technologies';

export const useTechnologies = () => technologies;
